import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Pricing from "./components/Pricing";
import Serverless from "./components/Serverless";
import Docs from "./components/Docs";
import Blog from "./components/Blog";
import ContactSales from "./components/ContactSales";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Domain from "./Pages/Domain/Domain";
import MainLayout from "./components/MainLayout";
import Servers from "./Pages/Servers/Servers";
import AddServer from "./components/Server/AddServer";
import Type from "./Pages/Type/Type";
import Location from "./Pages/Location/Location";
import ServerDetails from "./Pages/Servers/ServerDetails/ServerDetails";

import LandingHome from "./components/Landing/LandingHome";

import AuthWrapper from "./components/AuthWrapper";
const App = () => {
  return (
    <Router>
      {/* Routes for each component */}
      <Routes>
        <Route path="/" element={<LandingHome />} />
        <Route path="/landing-home" element={<Home />} />
        
        <Route path="/pricing" element={<Pricing />} />

        <Route path="/serverless" element={<Serverless />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact-sales" element={<ContactSales />} />
        <Route path="/login" element={<Login authType="login" />} />
         <Route path="/signup" element={<Login authType="signup" />} />
        {/* Pages with sidebar + topbar */}
        <Route path="/" element={<AuthWrapper><MainLayout /></AuthWrapper>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/domain" element={<Domain />} />
          <Route path="/servers" element={<Servers />} />
          <Route path="/servers/:id" element={<ServerDetails />} />
          <Route path="/addservers" element={<AddServer />} />
         
          <Route
            path="/addservers/type"
            element={
              <>
                <Type />
                <AddServer />
              </>
            }
          />

          <Route
            path="/addservers/location"
            element={
              <div>
                <Location />
              </div>
            }
          />
          <Route path="/addservers/image" element={<div>Image Page</div>} />
          <Route path="/addservers/network" element={<div>Network Page</div>} />
          <Route path="/addservers/ssh" element={<div>SSH Page</div>} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
